import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { admin } from "./admin";
import { user } from "./user";

const routes: Array<RouteRecordRaw> = [
  ...admin,
  ...user,
  {
    path: "/",
    name: "home",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/about",
    name: "about",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../views/LoginView.vue"),
  },
  {
    path: "/forgotpassword",
    name: "forgotpassword",
    component: () =>
      import("../components/PageComponents/Authentication/ForgotPassword.vue"),
  },
  {
    path: "/resetpassword",
    name: "resetpassword",
    component: () =>
      import("../components/PageComponents/Authentication/ResetPassword.vue"),
  },
  {
    path: "/signup",
    name: "signup",
    component: () => import("../views/SignUpView.vue"),
  },
  {
    path: "/collection_agent_reg",
    name: "collection_agent_reg",
    component: () =>
      import(
        "../components/PageComponents/Authentication/CollectionAgent1.vue"
      ),
  },
  {
    path: "/verification",
    name: "verification",
    component: () =>
      import("../components/PageComponents/Authentication/PartnerReg2.vue"),
  },
  {
    path: "/verification_v2",
    name: "verification_v2",
    component: () =>
      import(
        "../components/PageComponents/Authentication/CollectionAgent2.vue"
      ),
  },
  {
    path: "/partnersform",
    name: "partnersform",
    component: () =>
      import("../components/PageComponents/Authentication/PartnerReg3.vue"),
  },
  {
    path: "/collectionagent",
    name: "collectionagent",
    component: () => import("../views/Dashboard/User/CollectionAgentForm.vue"),
  },
  {
    path: "/samedaydelivery",
    name: "samedaydelivery",
    component: () => import("../views/SameDayDeliveryView.vue"),
  },
  {
    path: "/scheduleddelivery",
    name: "scheduleddelivery",
    component: () => import("../views/ScheduledDeliveryView.vue"),
  },
  {
    path: "/cashondelivery",
    name: "cashondelivery",
    component: () => import("../views/CashOnDeliveryView.vue"),
  },
  {
    path: "/insurance",
    name: "insurance",
    component: () => import("../views/InsuranceView.vue"),
  },
  {
    path: "/buyforme",
    name: "buyforme",
    component: () => import("../views/BuyForMeView.vue"),
  },
  {
    path: "/batchorders",
    name: "batchorders",
    component: () => import("../views/BatchOrdersView.vue"),
  },
  {
    path: "/payments",
    name: "payments",
    component: () => import("../views/PaymentView.vue"),
  },
  // Solutions routes
  {
    path: "/food-commerce",
    name: "foodcommerce",
    component: () => import("../views/FoodCommerceView.vue"),
  },
  {
    path: "/supermarkets",
    name: "supermarkets",
    component: () => import("../views/SupermarketsView.vue"),
  },
  {
    path: "/groceries",
    name: "groceries",
    component: () => import("../views/GroceriesView.vue"),
  },
  {
    path: "/fintech",
    name: "fintech",
    component: () => import("../views/FintechView.vue"),
  },
  {
    path: "/healthtech",
    name: "healthtech",
    component: () => import("../views/HealthTechView.vue"),
  },
  {
    path: "/ecommerce",
    name: "ecommerce",
    component: () => import("../views/ECommerceView.vue"),
  },
  {
    path: "/marketplace",
    name: "marketplace",
    component: () => import("../views/MarketplaceView.vue"),
  },
  {
    path: "/social-commerce",
    name: "socialcommerce",
    component: () => import("../views/SocialCommerceView.vue"),
  },
  // Partnerships routes
  {
    path: "/logistics-partners",
    name: "logisticspartners",
    component: () => import("../views/LogisticsPartnersView.vue"),
  },
  {
    path: "/anchor-partners",
    name: "anchorpartners",
    component: () => import("../views/AnchorPartnersView.vue"),
  },
  {
    path: "/independent-riders",
    name: "independentriders",
    component: () => import("../views/IndependentRidersView.vue"),
  },
  {
    path: "/affiliate-partners",
    name: "affiliatepartners",
    component: () => import("../views/AffiliatePartnersView.vue"),
  },
  // Product routes
  {
    path: "/rider-app",
    name: "riderapp",
    component: () => import("../views/RiderAppView.vue"),
  },
  {
    path: "/customer-app",
    name: "customerapp",
    component: () => import("../views/CustomerAppView.vue"),
  },
  {
    path: "/partner-dashboard",
    name: "partnerdashboard",
    component: () => import("../views/PartnerDashboardView.vue"),
  },
  {
    path: "/free-ecommerce",
    name: "freeecommerce",
    component: () => import("../views/FreeECommerceView.vue"),
  },
  // Pricing routes
  {
    path: "/distance-based",
    name: "distancebased",
    component: () => import("../views/DistanceBasedView.vue"),
  },
  {
    path: "/location-based",
    name: "locationbased",
    component: () => import("../views/LocationBasedView.vue"),
  },
  {
    path: "/subscription-pricing",
    name: "subscriptionpricing",
    component: () => import("../views/SubscriptionPricingView.vue"),
  },
  {
    path: "/flat-rate",
    name: "flatrate",
    component: () => import("../views/FlatRateView.vue"),
  },
  // Payment Options routes
  {
    path: "/pay-at-delivery",
    name: "payatdelivery",
    component: () => import("../views/PayAtDeliveryView.vue"),
  },
  {
    path: "/pay-online",
    name: "payonline",
    component: () => import("../views/PayOnlineView.vue"),
  },
  {
    path: "/post-paid",
    name: "postpaid",
    component: () => import("../views/PostPaidView.vue"),
  },
  // Resource routes
  {
    path: "/api-documentation",
    name: "apidocumentation",
    component: () => import("../views/ApiDocumentationView.vue"),
  },
  {
    path: "/plugins",
    name: "plugins",
    component: () => import("../views/PluginsView.vue"),
  },
  {
    path: "/blog",
    name: "blog",
    component: () => import("../views/BlogView.vue"),
  },
  {
    path: "/faq",
    name: "faq",
    component: () => import("../views/FaqView.vue"),
  },
  {
    path: "/case-studies",
    name: "casestudies",
    component: () => import("../views/CaseStudiesView.vue"),
  },
  {
    path: "/testimonials-page",
    name: "testimonialspage",
    component: () => import("../views/TestimonialsPageView.vue"),
  },
  {
    path: "/product-videos",
    name: "productvideos",
    component: () => import("../views/ProductVideosView.vue"),
  },
  // Company routes
  {
    path: "/vision-mission",
    name: "visionmission",
    component: () => import("../views/VisionMissionView.vue"),
  },
  {
    path: "/management",
    name: "management",
    component: () => import("../views/ManagementView.vue"),
  },
  {
    path: "/board",
    name: "board",
    component: () => import("../views/BoardView.vue"),
  },
  {
    path: "/employees",
    name: "employees",
    component: () => import("../views/EmployeesView.vue"),
  },
  {
    path: "/investors",
    name: "investors",
    component: () => import("../views/InvestorsView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // If the route has a hash (anchor), scroll to it
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: "smooth",
      };
    }
    // If the route has saved position (e.g., back/forward navigation)
    if (savedPosition) {
      return savedPosition;
    }
    // Default scroll to top behavior
    return { x: 0, y: 0 };
  },
});

export default router;
